/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DuplicateRateCardInput = {
    rateCardId?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type duplicateRateCardMutationModernMutationVariables = {
    input: DuplicateRateCardInput;
};
export type duplicateRateCardMutationModernMutationResponse = {
    readonly duplicateRateCard: {
        readonly rateCard: {
            readonly node: {
                readonly id: string;
                readonly name: string | null;
                readonly defaultRate: number | null;
                readonly parentRateCardId: string | null;
                readonly currency: string | null;
                readonly disabledRoles: ReadonlyArray<{
                    readonly id: string;
                } | null> | null;
                readonly rates: {
                    readonly edges: ReadonlyArray<{
                        readonly node: {
                            readonly id: string;
                            readonly rate: number | null;
                            readonly defaultRate: boolean | null;
                            readonly startDate: string | null;
                            readonly role: {
                                readonly id: string;
                            } | null;
                        } | null;
                    } | null> | null;
                } | null;
            } | null;
        } | null;
    } | null;
};
export type duplicateRateCardMutationModernMutation = {
    readonly response: duplicateRateCardMutationModernMutationResponse;
    readonly variables: duplicateRateCardMutationModernMutationVariables;
};



/*
mutation duplicateRateCardMutationModernMutation(
  $input: DuplicateRateCardInput!
) {
  duplicateRateCard(input: $input) {
    rateCard {
      node {
        id
        name
        defaultRate
        parentRateCardId
        currency
        disabledRoles {
          id
        }
        rates(first: 10000) {
          edges {
            node {
              id
              rate
              defaultRate
              startDate
              role {
                id
              }
            }
          }
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DuplicateRateCardInput!"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultRate",
  "storageKey": null
},
v3 = [
  (v1/*: any*/)
],
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DuplicateRateCardPayload",
    "kind": "LinkedField",
    "name": "duplicateRateCard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RateCardTypeEdge",
        "kind": "LinkedField",
        "name": "rateCard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RateCard",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "parentRateCardId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currency",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Role",
                "kind": "LinkedField",
                "name": "disabledRoles",
                "plural": true,
                "selections": (v3/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10000
                  }
                ],
                "concreteType": "RateTypeConnection",
                "kind": "LinkedField",
                "name": "rates",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RateTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Rate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rate",
                            "storageKey": null
                          },
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Role",
                            "kind": "LinkedField",
                            "name": "role",
                            "plural": false,
                            "selections": (v3/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "rates(first:10000)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "duplicateRateCardMutationModernMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "duplicateRateCardMutationModernMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "duplicateRateCardMutationModernMutation",
    "operationKind": "mutation",
    "text": "mutation duplicateRateCardMutationModernMutation(\n  $input: DuplicateRateCardInput!\n) {\n  duplicateRateCard(input: $input) {\n    rateCard {\n      node {\n        id\n        name\n        defaultRate\n        parentRateCardId\n        currency\n        disabledRoles {\n          id\n        }\n        rates(first: 10000) {\n          edges {\n            node {\n              id\n              rate\n              defaultRate\n              startDate\n              role {\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'ce94334e0b676243feb17884ef2e1099';
export default node;
